export function PokemonImage(props) {
  const url = props.pokemon?.img_url || "null";

  return <img src={url} {...props} />;
}
